import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable, of, tap } from 'rxjs'
import { Currency } from '../models/currency.model'
import { environment } from '@environments/environment'

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.referenceApiUrl

  private readonly currencies$$ = new BehaviorSubject<Currency[]>([])
  public readonly currencies$ = this.currencies$$.asObservable()

  private hasLoaded = false

  /**
   * Fetches the currency list from the API, but only if it hasn't been loaded before.
   * This prevents multiple API calls during the app's lifecycle.
   */
  public loadCurrencies(): Observable<Currency[]> {
    if (this.hasLoaded) {
      return of(this.currencies$$.getValue()) // Return the already loaded data
    }

    return this.http.get<Currency[]>(`${this.apiUrl}/currency`).pipe(
      tap(currencies => {
        this.currencies$$.next(currencies)
        this.hasLoaded = true
      })
    )
  }
}
